export default "__VITE_ASSET__C6_bqpUt__"